import html2canvas from "html2canvas";
import JsPDF from "jspdf";

const MARGIN_MM = 10;

/**
 * Export a DOM element to a multi-page A4 PDF.
 */
const exportElementToPdf = async (element, filename) => {
    if (!element) {
        throw new Error("No element to export");
    }

    const canvas = await html2canvas(element, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: false,
        useCORS: true,
        allowTaint: true,
        foreignObjectRendering: false,
    });

    const pdf = new JsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const contentWidth = pdfWidth - MARGIN_MM * 2;
    const contentHeight = pdfHeight - MARGIN_MM * 2;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const ratio = canvasWidth / contentWidth;
    const pageCanvasHeight = contentHeight * ratio;

    let renderedHeight = 0;
    let page = 0;

    while (renderedHeight < canvasHeight) {
        const sliceHeight = Math.min(pageCanvasHeight, canvasHeight - renderedHeight);
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = sliceHeight;

        const ctx = pageCanvas.getContext("2d");
        ctx.drawImage(canvas, 0, renderedHeight, canvasWidth, sliceHeight, 0, 0, canvasWidth, sliceHeight);

        const imgData = pageCanvas.toDataURL("image/png");
        const imgHeightMm = sliceHeight / ratio;

        if (page > 0) {
            pdf.addPage();
        }

        pdf.addImage(imgData, "PNG", MARGIN_MM, MARGIN_MM, contentWidth, imgHeightMm);

        renderedHeight += sliceHeight;
        page += 1;
    }

    pdf.save(filename);
};

export default exportElementToPdf;
